import React, { useMemo } from 'react';
import DynamicComponentRenderer from '../../utility/DynamicComponentRenderer';

type Props = {
  source: string;
  data?: unknown;
  allowedModules: string[];
};

export default function PreviewPane({ source, data, allowedModules }: Props) {
  // Stable identity so the renderer doesn't re-transpile on unrelated parent
  // re-renders (e.g. every editor keystroke) — only when source/data change.
  const props = useMemo(() => (data ? { data } : {}), [data]);
  return (
    <div style={{
      padding: '1.5rem', border: '1px solid #e2e8f0', borderRadius: 8,
      background: 'white', minHeight: 400, overflow: 'auto',
    }}>
      <DynamicComponentRenderer
        componentCode={source}
        props={props}
        allowedModules={allowedModules}
      />
    </div>
  );
}
